import React, {useState} from "react"
import {Button, Card, Form, Icon, Input, Layout, Spin} from "antd"
import {ReactComponent as Logo} from "../../assets/logo.svg"
import library from '../../library'
import "./styles.scss"

const {messages} = library
const Content = Layout.Content
const FormItem = Form.Item

type Props = {
	token: string,
	stage: string,
}

export const RequestMailPage: React.FC<Props> = ({token, stage}: Props) => {
	if (stage === 'password') stage = 'production'
	const [loading, setLoading] = useState(false),
		[responseReceived, setResponseReceived] = useState(false),
		[errorMessage, setErrorMessage] = useState(""),
		[email, setEmail] = useState("")

	const handleSubmit = async (e: React.MouseEvent<any>) => {
		e.preventDefault()
		setLoading(true)
		try {
			if (!email.includes("@")) throw new Error(messages.INVALID_EMAIL)
			const response = await library.postQuery(`mutation { requestResetEmail(email:"${email}") }`, stage)
			if (!response.requestResetEmail) throw new Error(messages.ACCOUNT_NOT_FOUND)
			if (response.requestResetEmail.success) {
				setResponseReceived(true)
			}
		} catch (error) {
			setErrorMessage(error.message)
			setLoading(false)
		}
	}

	return (
		<Content className={"content-wrap"}>
			{loading ? responseReceived ? <div><Icon type={"mail"} /> パスワードリセットメールが送信されました。メールの受信トレイを確認してください。</div> : <Spin size={"large"}/> : <Card className={"card"}>
				<div className={"logo-wrap"}>
					<Logo className={"logo"}/>
				</div>
				<p style={{marginBottom: "2em"}}>
					アカウントに関連付けられているメールアドレスを入力してください。
				</p>
				<Form onSubmit={handleSubmit} className="login-form">
					<FormItem>
						<Input
							prefix={
								<Icon
									type="mail"
									style={{
										fontSize: 13,
									}}
								/>
							}
							value={email}
							onChange={(e) => {
								setEmail(`${(e.target as HTMLInputElement).value}`)
							}}
							placeholder="Email"
						/>

					</FormItem>
					{errorMessage && <p className={"error-message-text"}>{errorMessage}</p>}
					<FormItem>
						<Button
							className={"full-width"}
							type="primary"
							htmlType="submit"
							size="large">
							パスワードの再設定
						</Button>
					</FormItem>
					<div>
						<p>
							未登録の方は、SignManアカウントを<a href={"http://member.signman.jp/register"}>新規登録</a>してください。
						</p>
					</div>
				</Form>
			</Card>}
		</Content>
	)
}

export default RequestMailPage
